import React from 'react'
import { Col, Row } from 'react-bootstrap'

/**
 * Renders a big title with children to the side
 *
 * @param {string} title The big title
 * @param {string} id Id for the title
 * @param {JSX.Element} children Children that should be displayed to the side
 * @param {string} titleAlignment Where to display the title. Can be 'left', 'right' or 'top'
 */
const HeadingSection = ({ title, children, titleAlignment = 'left', id }) => {
  if (titleAlignment === 'right') {
    return (
      <Row className="heading-section__container right">
        <Col xs={12} lg={7}>
          {children}
        </Col>
        <Col xs={12} lg={5} className="heading-section__title-container">
          <h2 className="heading-section__title" id={id}>
            {title}
          </h2>
        </Col>
      </Row>
    )
  } else if (titleAlignment === 'top') {
    return (
      <Row className="heading-section__container top">
        <Col xs={12} lg={12} className="heading-section__title-container mb-md-5 pb-lg-5">
          <h2 className="heading-section__title" id={id}>
            {title}
          </h2>
        </Col>
        <Col xs={12} lg={12}>
          {children}
        </Col>
      </Row>
    )
  } else {
    return (
      <Row className="heading-section__container">
        <Col xs={12} lg={5} className="heading-section__title-container">
          <h2 className="heading-section__title" id={id}>
            {title}
          </h2>
        </Col>
        <Col xs={12} lg={7}>
          {children}
        </Col>
      </Row>
    )
  }
}

export default HeadingSection
